"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortStoresBy = exports.updateStoresOpenState = exports.getMappedStoreInformation = void 0;
const getTodaysOpeningHours = (store, currantDate) => {
    let result;
    if (store.scheduleEntries) {
        store.scheduleEntries.map(day => {
            if (!result) {
                const myDate = new Date(day.date);
                if (myDate.getDate() === currantDate.getDate() && myDate.getMonth() === currantDate.getMonth()) {
                    result = day;
                }
            }
        });
    }
    return result;
};
const isOpen = (store) => {
    const currantDate = new Date();
    const time = currantDate.getHours() * 60 + currantDate.getMinutes();
    const today = getTodaysOpeningHours(store, currantDate);
    return Boolean(today && time > today.openTimeInMinutes && time < today.closeTimeInMinutes);
};
const isOpenLate = (store, openLateTimeInMinutes) => {
    const currantDate = new Date();
    const today = getTodaysOpeningHours(store, currantDate);
    return Boolean(today && today.closeTimeInMinutes > openLateTimeInMinutes);
};
const getMappedStoreInformation = (stores, additionalStoresData) => stores
    .filter(store => store.geographic.latitude && store.geographic.longitude)
    .map(store => {
    const additionalStoreData = additionalStoresData.find(item => item.code === String(store.code));
    return Object.assign(Object.assign({}, store), { relativeStorePagePath: (additionalStoreData === null || additionalStoreData === void 0 ? void 0 : additionalStoreData.relativeStorePagePath) || '', image: (additionalStoreData === null || additionalStoreData === void 0 ? void 0 : additionalStoreData.image) || null });
});
exports.getMappedStoreInformation = getMappedStoreInformation;
const updateStoresOpenState = (stores, openAfterTime) => stores.map(store => (Object.assign(Object.assign({}, store), { openNow: isOpen(store), openLate: isOpenLate(store, openAfterTime), openSunday: !store.scheduleEntries[6].closed })));
exports.updateStoresOpenState = updateStoresOpenState;
const sortStoresBy = (stores, sortBy, selectedStoreId) => {
    const sortedStores = stores.sort((storeA, storeB) => {
        if (sortBy === 'distance') {
            return storeA.distance - storeB.distance;
        }
        else if (sortBy === 'storeName') {
            return storeA.storeName.localeCompare(storeB.storeName);
        }
        return -1;
    });
    return selectedStoreId ? moveItemToFront(sortedStores, selectedStoreId) : sortedStores;
};
exports.sortStoresBy = sortStoresBy;
const moveItemToFront = (stores, storeId) => {
    const index = stores.findIndex(item => item.storeId === storeId);
    if (index > -1) {
        const [item] = stores.splice(index, 1);
        stores.unshift(item);
    }
    return stores;
};
//# sourceMappingURL=StoreUtil.js.map